import { Bar, BarChart, CartesianGrid, Cell, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import type { PeriodoCxc, PuntoFlujo, PuntoMensual } from '@leadsphere/types';

import { fmtCorto, fmtMXN } from '../../lib/moneda.js';

const etiqueta = (p: PeriodoCxc) => `${p.mes.slice(0, 3)} ${String(p.anio).slice(2)}`;
const esUltimo = (p: PeriodoCxc, u: PeriodoCxc) => p.anio === u.anio && p.mes === u.mes;
// recharts tipa el valor como ValueType (número, texto o arreglo): se recibe como unknown.
const tooltipMonto = (v: unknown) => fmtMXN(Number(v));

export function GraficaFacturado({ datos, ultimo }: { datos: PuntoMensual[]; ultimo: PeriodoCxc }) {
  const filas = datos.map(p => ({ ...p, etiqueta: etiqueta(p), actual: esUltimo(p, ultimo) }));
  return (
    <div className="reportes-card">
      <div className="reportes-card-titulo">Facturado por mes de servicio</div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={filas}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="etiqueta" fontSize={10} interval={0} />
          <YAxis tickFormatter={fmtCorto} fontSize={11} width={60} />
          <Tooltip formatter={tooltipMonto} />
          <Legend />
          <Bar dataKey="cobrado" name="Cobrado" stackId="f" fill="var(--success)">
            {filas.map(f => <Cell key={f.etiqueta} fillOpacity={f.actual ? 1 : 0.55} />)}
          </Bar>
          <Bar dataKey="por_cobrar" name="Por cobrar" stackId="f" fill="var(--danger)">
            {filas.map(f => <Cell key={f.etiqueta} fillOpacity={f.actual ? 1 : 0.55} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function GraficaFlujo({ datos, ultimo, sinFecha }: { datos: PuntoFlujo[]; ultimo: PeriodoCxc; sinFecha: number }) {
  const filas = datos.map(p => ({ ...p, etiqueta: etiqueta(p), actual: esUltimo(p, ultimo) }));
  return (
    <div className="reportes-card">
      <div className="reportes-card-titulo">Flujo de cobranza (por fecha de pago)</div>
      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={filas}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="etiqueta" fontSize={10} interval={0} />
          <YAxis tickFormatter={fmtCorto} fontSize={11} width={60} />
          <Tooltip formatter={tooltipMonto} />
          <Bar dataKey="cobrado" name="Cobrado" fill="var(--primary, #2563eb)">
            {filas.map(f => <Cell key={f.etiqueta} fillOpacity={f.actual ? 1 : 0.55} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      {sinFecha > 0 && (
        <div className="reportes-nota">{sinFecha} cobros sin fecha de pago no aparecen en el flujo.</div>
      )}
    </div>
  );
}
